import { useCallback } from "react";
import { Checkbox } from "@mantine/core";

interface ReportReviewRequirementCellProps {
  prefixId: string;
  prefixCode: string;
  pathologistUserId: string;
  pathologistName: string;
  reviewRequired: boolean;
  disabled: boolean;
  onChange: (
    prefixId: string,
    pathologistUserId: string,
    required: boolean
  ) => void;
}

export function ReportReviewRequirementCell({
  prefixId,
  prefixCode,
  pathologistUserId,
  pathologistName,
  reviewRequired,
  disabled,
  onChange,
}: ReportReviewRequirementCellProps) {
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange(prefixId, pathologistUserId, event.currentTarget.checked);
    },
    [onChange, pathologistUserId, prefixId]
  );

  return (
    <Checkbox
      mx="auto"
      checked={reviewRequired}
      disabled={disabled}
      onChange={handleChange}
      aria-label={`Require review for ${prefixCode} reports signed by ${pathologistName}`}
    />
  );
}
